/** Shared Smart Vehicle Reception contract (dashboard). Keep in sync with Flutter reception_contract.dart */

export const RECEPTION_BODY_TYPES = [
  'sedan',
  'hatch',
  'suv',
  'coupe',
  'pickup',
  'van',
];

export const RECEPTION_FUEL_LEVELS = ['empty', '1/4', '1/2', '3/4', 'full'];

export const RECEPTION_REQUIRED_SIDES = ['front', 'rear', 'left', 'right'];

export const RECEPTION_OPTIONAL_SIDES = ['roof', 'interior'];

export const RECEPTION_PHOTO_SIDES = [
  ...RECEPTION_REQUIRED_SIDES,
  ...RECEPTION_OPTIONAL_SIDES,
];

export function emptyDamageDiagram(bodyType = 'sedan') {
  return {
    bodyType,
    marks: [],
    noDamage: false,
    updatedAt: null,
  };
}

export function normalizeDamageDiagram(value) {
  const raw = value && typeof value === 'object' ? value : {};
  const bodyType = RECEPTION_BODY_TYPES.includes(raw.bodyType)
    ? raw.bodyType
    : 'sedan';
  const marks = Array.isArray(raw.marks)
    ? raw.marks
        .filter((m) => m && typeof m === 'object')
        .map((m) => ({
          id: m.id || crypto.randomUUID(),
          zone: m.zone || 'body',
          x: Number(m.x) || 0.5,
          y: Number(m.y) || 0.5,
          note: m.note || '',
        }))
    : [];
  return {
    bodyType,
    marks,
    noDamage: !!raw.noDamage,
    updatedAt: raw.updatedAt || null,
  };
}

export function normalizeReceptionPhotos(value) {
  if (!Array.isArray(value)) return [];
  return value
    .filter((item) => item && typeof item === 'object' && item.path)
    .map((item) => ({
      side: item.side || 'front',
      bucket: item.bucket || 'vehicle-photos',
      path: item.path,
      name: item.name || item.path,
    }));
}

/**
 * @returns {string[]} validation error keys (i18n keys under reception.*)
 */
export function validateReceptionDraft({
  mileage,
  fuelLevel,
  photos,
  diagram,
  vin,
  vinUnavailable,
  signatureUrl,
  finalize = false,
}) {
  const errors = [];
  const miles = Number(mileage);
  if (!Number.isFinite(miles) || miles < 0) {
    errors.push('reception.errMileage');
  }
  if (!RECEPTION_FUEL_LEVELS.includes(fuelLevel)) {
    errors.push('reception.errFuel');
  }
  if (!RECEPTION_BODY_TYPES.includes(diagram?.bodyType)) {
    errors.push('reception.errBodyType');
  }

  if (!finalize) return errors;

  const sides = new Set(
    (photos || []).filter((p) => p?.path).map((p) => p.side),
  );
  for (const side of RECEPTION_REQUIRED_SIDES) {
    if (!sides.has(side)) errors.push(`reception.errPhoto.${side}`);
  }

  const noDamage = !!diagram?.noDamage;
  const marks = Array.isArray(diagram?.marks) ? diagram.marks : [];
  if (!noDamage && marks.length === 0) {
    errors.push('reception.errDamage');
  }

  if (!vinUnavailable && !String(vin || '').trim()) {
    errors.push('reception.errVin');
  }

  if (!String(signatureUrl || '').trim()) {
    errors.push('reception.errSignature');
  }

  return errors;
}

export function receptionIsComplete(jobCard) {
  return !!jobCard?.reception_completed_at;
}
